import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import Skeleton from "react-loading-skeleton";
import { useUser } from "../../../hooks/useUser";
import { Container } from "../../Container/Container"

export const StatisticsProfile = () => {
    const router = useRouter();
    const { isLoading, data } = useUser(router.query.username as string);
    const { t } = useTranslation('common');

    return (
        <div className="flex flex-row gap-x-1 my-1 font-semibold text-center">
            <Container className="flex-1 pt-[15px] pb-[10px]" topL={false} topR={false} bottomL={false} bottomR={false}>
                <h4 className="text-3xl">{isLoading ? <Skeleton className="w-full " /> : data?.views.toLocaleString()}</h4>
                <p className="font-normal">{t('views')}</p>
            </Container>
            <Container className="flex-1 pt-[15px] pb-[10px]" topL={false} topR={false} bottomL={false} bottomR={false}>
                <h4 className="text-3xl">-</h4>
                <p className="font-normal">{t('followers')}</p>
            </Container>
        </div>
    )
}